import { createBaseTableHeadCellDriver } from '../base-table-head-cell/driver';
export var createTableHeadCellDriver = function (wrapper) {
    var base = createBaseTableHeadCellDriver(wrapper);
    return {
        click: function () { return base.click(); },
        hasClass: base.hasClass
    };
};
//# sourceMappingURL=driver.js.map